module.exports = __webpack_public_path__ + "fonts/IndivisibleWebRegular.56d11126.woff";